/// <reference path='../_all.ts' />

module library {
  'use strict';


  export class Language {
    constructor(
      public LanguageAlternative :number,
      public LanguageCode :string,
      public LanguageID:number,
      public LanguageIcon:string,
      public LanguageName:string,
      public LanguageSiteCode:string
      ) { }
  }

}